//------------------------------------------------------------------------
// Make iframes responsive, preserving their aspect ratio (like FitVid.js)
//------------------------------------------------------------------------
import FluidIframe from "@threespot/fluid-iframe";

const init = () => {
  document.querySelectorAll(".u-richtext > iframe").forEach(el => new FluidIframe(el));
};

// Init on initial page load
init();

